/*******************************************************************************
 *
 *              ! DO NOT PUT ANYTHING SECURE IN THESE FILES !
 *
 ******************************************************************************/
if (typeof window === 'undefined') {
    // @ts-ignore
    global.window = {};
}
export * from './types';
export const ligrEnv = window.LIGR_ENV;
export const CONFIG = Object.assign(Object.assign({}, ligrEnv), { LOCAL_STORAGE_TOKEN_KEY: 'ligrToken' });
//# sourceMappingURL=index.js.map